class BESSAppProjectSupportDocItem extends BESSAppBase {

    constructor(parent, root) {
        super();
        this.root = root;
        this.parent = parent;
        this.docId = this.root.attr('data-doc-id');
        this.saveRequired = false;
        this.saving = false;

        this.initialising = true;

        this.requirementContent = this.root.find('.app-requirement-content');
        this.selectedDocument = null;
        this.docName = this.root.find('.app-doc-name');
        this.openDoc = this.root.find('.app-doc-open');
        this.docAction = this.root.find('.app-doc-action');
        this.docAction.bindClickEvent(this, this.#onModifyDoc);

        this.removeDocBtn = this.root.find('.app-remove-doc');
        this.removeDocBtn.bindClickEvent(this, this.#onRemoveDoc);

        this.notApplicable = this.root.find('.app-document-item-na');
        this.notApplicable.change(this.#notApplicableChanged.bind(this));

        this.#updateState();

        this.commentContainer = this.root.find('.app-comments-container');
        this.commentInput = this.commentContainer.find('textarea');
        initMaterialTextControl(this.commentInput, this.#updateComment.bind(this));
        this.initialising = false;


    }

    updated(docId, docName, docType, isValid, url = null) {
        this.root.find('.tag-complete').showIf(isValid);
        this.root.find('.tag-incomplete').showIf(!isValid);
        this.root.addClassIf('supplied', isValid);
        this.docName.attr('data-doc-id', docId);
        this.openDoc.attr('href', url != null ? url : '#').showIf(url != null);

        if (isValid) {
            this.docName.text('' + docName + ' (' +
                (parseInt(docType) === BESSAppProjectDoc.PROJECT_DOCUMENT_TYPE_UPLOADED ?
                    "Uploaded" : "To be printed")
                + ')');
            this.selectedDocumentId = '' + docId;
        } else {
            this.docName.text('No document provided');
            this.selectedDocumentId = null;
        }

        this.#updateState();
    }

    removedDocument(docId) {
        if (this.docName.attr('data-doc-id') === docId) {
            this.updated('', '', 0, false);
        }
    }

    #notApplicableChanged() {
        this.#updateState();
        let notApplicable = this.notApplicable.isChecked();
        this.parent.api().updateSupportingDocumentNotApplicable(this.docId, notApplicable,
            function (result) {
                this.root.addClassIf('supplied', result.state['completed']);
                this.root.find('.tag-complete').showIf(result.state['completed']);
                this.root.find('.tag-incomplete').showIf(!result.state['completed']);
                this.parent.updateState(result.state);


            }.bind(this));

    }

    #updateState() {
        let completed = this.root.hasClass('supplied');
        let notApplicable = this.notApplicable.isChecked();
        this.root.find('.app-document-inputs').addClassIf('not-applicable', notApplicable);
        if (!completed) {
            this.selectedDocumentId = null;
            BESSAppTooltip.update(this.docAction, 'No Supporting Documentation has been provided. Select to add Supporting Documentation for this requirement.');
        } else {
            this.selectedDocumentId = this.docName.attr('data-doc-id');
            BESSAppTooltip.update(this.docAction, 'Select to change the Supporting Documentation for this requirement.');
        }
    }

    #onModifyDoc() {
        BESSAppTooltip.close();
        this.parent.supportingDocModal.showFor(this);
    }

    #onRemoveDoc() {
        let docId = this.docName.attr('data-doc-id');
        let docUsedInMultiplePlaces = $('.app-doc-name[data-doc-id="' + docId + '"]').length > 1;
        if (docUsedInMultiplePlaces) {
            this.askUserToConfirmSeriousOperation(
                'Remove Supporting Document',
                'Remove this Supporting Document from this Supporting Evidence requirement? ' +
                'This document is being used in multiple places so will still be available.',
                this.#onConfirmRemoveDoc.bind(this),
                'Yes - remove',
                'Cancel',
            )
        } else {
            bootbox.dialog({
                title: 'Remove Supporting Document',
                message: 'Remove this Supporting Document? You can elect to keep the document for use in other requirements.',
                backdrop: true,
                closeButton: false,
                swapButtonOrder: true,
                buttons: {
                    confirm: {
                        label: 'Remove and keep',
                        className: 'btn-primary',
                        callback: function () {
                            this.#onConfirmRemoveDoc()
                        }.bind(this),
                    },
                    confirmAndDelete: {
                        label: 'Remove and delete',
                        className: 'btn-danger',
                        callback: function () {
                            this.#onConfirmRemoveDocAndDelete()
                        }.bind(this),
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-secondary'
                    }
                },
            });
        }
    }

    #onConfirmRemoveDocAndDelete() {
        this.#onConfirmRemoveDoc(true);
    }

    #onConfirmRemoveDoc(deleteDoc = false) {
        this.parent.api().unlinkSupportingDocument(this.docId, deleteDoc, this.#onRemovedDoc.bind(this))
    }

    #onRemovedDoc(result) {
        this.updated('', '', 0, false);
        this.parent.updateState(result.state);
    }

    #updateComment() {
        this.saveRequired = true;
        if (!this.initialising) {
            this.doDelayed(this.#saveCommentState.bind(this), 500);
        }
    }

    #saveCommentState() {
        if (!this.saveRequired) return;
        if (this.saving) {
            this.doDelayed(this.#saveCommentState.bind(this), 500);
            return;
        }
        this.saving = true;
        let comment = this.commentInput.val().trim();
        this.saveRequired = false;
        this.parent.api().updateSupportingDocumentComment(
            this.docId, comment, this.#onSavedCommentState.bind(this));
    }

    #onSavedCommentState() {
        this.saving = false;
    }
}